import { Colors, Lightning, Log } from '@lightningjs/sdk';
import { Helper } from '../../lib/helper';
import { InputField } from "@lightningjs/ui";
import KeyboardNumeric from '../../ui-elements/keyboard-numeric';
import ParentalButton from '../../ui-elements/parental-button';

export default class CreatePinScreen extends Lightning.Component {

    _previousInputState: any
    static override _template() {
        return {
            w: 1920,
            h: 1080,
            flex: { justifyContent: 'center', alignItems: 'center' },
            Contaier: {
                w: 700,
                h: 600,
                rect: true,
                collision: true,
                color: 0xff000000,
                flex: { direction: 'column' },
                Label: {
                    x: 20, y: 20, h: 90,
                    text: { text: 'Create Pin', fontFace: Helper.getFontFamily('Regular'), fontSize: 36, textColor: 0xffffffff }
                },
                Body: {
                    rect: true,
                    h: 420,
                    color: 0xff222222,
                    flex: { justifyContent: 'center', alignItems: 'center' },
                    collision: true,
                    InputWrapper: {
                        flexItem: { grow: 1 },
                        flex: { direction: 'column', justifyContent: 'center', alignItems: 'center' },
                        collision: true,
                        EnterWrapper: {
                            w: 300,
                            flex: { direction: 'column' },
                            collision: true,
                            zIndex: 82,
                            EnterTitle: {
                                h: 50,
                                padding: 15,
                                text: { text: 'Enter PIN', fontSize: 28, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff },
                            },
                            EnterPinField: {
                                w: 300,
                                h: 100,
                                padding: 30,
                                collision: true,
                                InputField: {
                                    y: 30,
                                    type: InputField,
                                    passwordMode: true,
                                    autoHideCursor:true,
                                    inputText: {
                                        textColor: Colors("white").get(),
                                        fontSize: 60,
                                        letterSpacing: 20,
                                        lineHeight: 50,
                                        verticalAlign: 'middle',
                                        paddingLeft: 70,
                                    },
                                },
                                Stroke: {
                                    x: 3,
                                    y: 3,
                                    w: (w) => w + 3,
                                    h: (h) => h + 3,
                                    alpha: 0.2,
                                    rect: true,
                                    color: 0x66ffffff,
                                    shader: {
                                        type: Lightning.shaders.RoundedRectangle,
                                        radius: 10,
                                        stroke: 6,
                                        strokeColor: 0xfff34966
                                    }
                                }
                            }
                        },
                        ReEnterWrapper: {
                            w: 300,
                            flex: { direction: 'column' },
                            collision: true,
                            zIndex: 82,
                            ReEnterTitle: {
                                h: 50, y: 15,
                                padding: 15,
                                text: { text: 'Re-Enter PIN', fontSize: 28, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff },
                            },
                            ReEnterPinField: {
                                w: 300,
                                h: 100,y: 15,
                                padding: 30,
                                InputField: {
                                    y: 30,
                                    type: InputField,
                                    passwordMode: true,
                                    inputText: {
                                        textColor: Colors("white").get(),
                                        fontSize: 60,
                                        letterSpacing: 20,
                                        lineHeight: 50,
                                        verticalAlign: 'middle',
                                        paddingLeft: 70,
                                    },
                                },
                                Stroke: {
                                    x: 3,
                                    y: 3,
                                    w: (w) => w + 3,
                                    h: (h) => h + 3,
                                    alpha: 0.2,
                                    rect: true,
                                    color: 0x66ffffff,
                                    shader: {
                                        type: Lightning.shaders.RoundedRectangle,
                                        radius: 10,
                                        stroke: 7,
                                        strokeColor: 0xfff34966
                                    }
                                }
                            }
                        }
                    }
                },
                Footer: {
                    w: (w) => w,
                    h: 100,
                    collision: true,
                    SaveButton: {
                        x: 180, y: 10,
                        type: ParentalButton,
                        mode: 'disabled',
                        label: 'Save PIN',
                        icon: null,
                        collision: true,
                        zIndex: 82,
                        w: 300,
                    }
                },
                ErrorDisplay: {
                    h: 50, x: 200, y: 10,
                    padding:10,
                    rect:true,
                    color: 0xff000000,
                    Title: {
                        text: { text: 'Error:', fontSize: 28, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff  },
                    },
                    visible: false,
                }
            },
            NumericKeyPad: {
                w: 982,
                h: 80,
                x: (w)=>w/2,
                y: (h)=>h-50,
                mountX: 0.5,
                mountY: 1,
                collision:true,
                zIndex: 83,
                forceZIndexContext:true,
                flexItem: false,
                type: KeyboardNumeric,
                maxCharacters: 4,
                visible: false,
                signals: {
                    'onInputChanged': true
                }
            }
        }
    }

    override _getFocused(): Lightning.Component | null | undefined {
        return null
    }

    override _init(): void {
        this._setState('EnterWrapperState')
    }

    override _handleKey(e: KeyboardEvent): boolean | void {
        return true
    }

    override _handleBack(e: KeyboardEvent): boolean | void {
        this.signal('back')
        return true
    }

    onInputChanged(event) {
        Log.info('onInputChanged: ', event)
        if (
            this.tag('EnterPinField.InputField').input.length == 4 &&
            this.tag('ReEnterPinField.InputField').input.length == 4
        ) {
            this.tag('SaveButton').mode = 'unfocused'
            this._setState('SaveButtonState')
        } else {
            this.tag('SaveButton').mode = 'disabled'
        }
    }

    validateAndSave() {
        const inputEnter = this.tag('EnterPinField.InputField').input
        const tinputReEnter = this.tag('ReEnterPinField.InputField').input
        if (inputEnter !== tinputReEnter) {
            this.tag('ErrorDisplay.Title').text.text = 'Error: PIN Mismatch'
            this.tag('ErrorDisplay').visible=true
            this._setState('ReEnterWrapperState')
        } else {
            Helper.setPIN(inputEnter)
            this.signal('profile')
        }
    }

    static override _states(): Lightning.Component.Constructor[] {
        return [
            class EnterWrapperState extends this {
                override $enter(event: any) {
                    this.tag("EnterPinField.InputField").toggleCursor()
                    this.tag("EnterPinField.Stroke").alpha = 1
                }
                override $exit(event: any) {
                    this.tag("EnterPinField.InputField").toggleCursor()
                    this.tag("EnterPinField.Stroke").alpha = this.tag("EnterPinField").selected ? 0.5 : 0.2
                }
                override _getFocused() {
                    return this.tag('EnterPinField.InputField')
                }

                override _handleEnter(e: KeyboardEvent): boolean | void {
                    this.tag('EnterPinField').selected = true
                    this.tag('ReEnterPinField').selected = false
                    this.tag("ReEnterPinField.Stroke").alpha = this.tag("ReEnterPinField").selected ? 0.5 : 0.2
                    this._previousInputState = 'EnterWrapperState'
                    this.tag('NumericKeyPad').inputField(this.tag('EnterPinField.InputField'))
                    this._setState('NumericKeyPadState')
                }

                override _handleUp(e: KeyboardEvent): boolean | void {
                    return true
                }

                override _handleDown(e: KeyboardEvent): boolean | void {
                    this._setState('ReEnterWrapperState')
                    return true
                }
            },

            class ReEnterWrapperState extends this {
                override $enter(event: any) {
                    this.tag("ReEnterPinField.InputField").toggleCursor(true)
                    this.tag("ReEnterPinField.Stroke").alpha = 1
                }
                override $exit(event: any) {
                    this.tag("ReEnterPinField.InputField").toggleCursor(false)
                    this.tag("ReEnterPinField.Stroke").alpha = this.tag("ReEnterPinField").selected ? 0.5 : 0.2
                }
                override _getFocused() {
                    return this.tag('ReEnterPinField.InputField')
                }

                override _handleEnter(e: KeyboardEvent): boolean | void {
                    this.tag('ReEnterPinField').selected = true
                    this.tag('EnterPinField').selected = false
                    this.tag("EnterPinField.Stroke").alpha = this.tag("EnterPinField").selected ? 0.5 : 0.2
                    this._previousInputState = 'ReEnterWrapperState'
                    this.tag('NumericKeyPad').inputField(this.tag('ReEnterPinField.InputField'))
                    this._setState('NumericKeyPadState')
                }

                override _handleUp(e: KeyboardEvent): boolean | void {
                    this._setState('EnterWrapperState')
                    return true
                }

                override _handleDown(e: KeyboardEvent): boolean | void {
                    if (this.tag('SaveButton').mode == 'disabled') {
                        return true
                    }
                    this._setState('SaveButtonState')
                    return true
                }
            },

            class NumericKeyPadState extends this {
                override $enter(event: any) {
                    this.tag('NumericKeyPad').visible = true
                }
                override $exit(event: any) {
                    this.tag('NumericKeyPad').visible = false
                }
                override _getFocused() {
                    return this.tag('NumericKeyPad')
                }

                override _handleKey(e: KeyboardEvent): boolean | void {
                    return true
                }

                override _handleEnter(e: KeyboardEvent): boolean | void {
                    return true
                }

                override _handleBack(e: KeyboardEvent): boolean | void {
                    if (this._previousInputState) {
                        this._setState(this._previousInputState)
                    } else {
                        this._setState('EnterWrapperState')
                    }
                }
            },
            class SaveButtonState extends this {
                override $enter(event: any) {
                    //this.tag("ItemInfo").show()
                }
                override $exit(event: any) {
                    //this.tag("ItemInfo").hide()
                }
                override _getFocused() {
                    return this.tag('SaveButton')
                }

                override _handleUp(e: KeyboardEvent): boolean | void {
                    this._setState('ReEnterWrapperState')
                    return true
                }

                override _handleDown(e: KeyboardEvent): boolean | void {
                    return true
                }

                override _handleEnter(e: KeyboardEvent): boolean | void {
                    this.validateAndSave()
                }
            }

        ]
    }

    _handleClick(target) {
        Log.info(target.ref)
        if(target.ref === 'EnterWrapper') {
            this._setState('EnterWrapperState')
            this._handleEnter()
        } else if(target.ref === 'ReEnterWrapper') {
            this._setState('ReEnterWrapperState')
            this._handleEnter()
        } else if(target.ref === 'SaveButton') {
            if (this.tag('SaveButton').mode !== 'disabled') {
                this._setState('SaveButtonState')
                this._handleEnter()
            }
        }
    }
}